import { GetServerSidePropsContext } from 'next';
import { useEffect, useState } from 'react';
import { getRequestLanguage } from '@/website/constants/locales';
import { ContentfulPageProps, getContentfulData } from '@/website/lib/getContentfulData';
import { getGoodsInTransitWebsiteCrawlerHeadData } from '@/website/util/crawler';
import { PromotionGetResponse, getAuthenticatedPromotionBySlug } from '@jove-frontend/uikit';
import GoodsInTransitPage from './';

const SLUG = 'goods-in-transit';
export async function getServerSideProps(context: GetServerSidePropsContext) {
  const language = getRequestLanguage(context.locale, context.req.headers.cookie);

  return getContentfulData(context, SLUG, {
    metaInfo: {
      title: getGoodsInTransitWebsiteCrawlerHeadData(language)?.title,
      description: getGoodsInTransitWebsiteCrawlerHeadData(language)?.description,
      images: '/goods-in-transit-landing.png',
    },
    useNewLogic: true,
    dataFileName: 'goods-in-transit-landing-data.json',
    activeLanguage: language,
  });
}

export default function GoodsInTransitPagePromotion(props: ContentfulPageProps) {
  const { promotion, isPreview, promotionSlug, post, metadata } = props;
  const [newPromotion, setNewPromotion] = useState<PromotionGetResponse | null>(null);

  async function getPromotion() {
    if (isPreview && promotionSlug) {
      try {
        const previewPromotion = await getAuthenticatedPromotionBySlug(promotionSlug);
        setNewPromotion(previewPromotion);
      } catch (error) {
        console.error(`Error getting preview promotion slug '${promotionSlug}'`, error);
      }
    }
  }

  useEffect(() => {
    getPromotion();
  }, [isPreview, promotionSlug]);

  return (
    <GoodsInTransitPage promotion={promotion || newPromotion} post={post} isPreview={isPreview} promotionSlug={promotionSlug} metadata={metadata} />
  );
}
